import { AnyAction } from 'redux';
import {
  AdressvorschlagPayload,
  CALLER_ID,
  GlobalActions,
} from '@ps20-frontend/shop-integration-redux';
import { App, BasisAdresse, ThhHundVorbelegungdaten } from '@ps20-frontend/frontend-models';
import { ThhHundActions } from '../thhHundActions';

export const risikoortReducer = function (
  sectionState: BasisAdresse = null,
  action: AnyAction,
): BasisAdresse {
  switch (action.type) {
    case ThhHundActions.PLZ_CHANGED: {
      const plz = action.payload;
      return {
        plz,
        strasse: '',
        hausnummer: '',
        ort: '',
      };
    }
    case GlobalActions.ADDRESSVORSCHLAG_SUCCESSFUL: {
      const payload: AdressvorschlagPayload = action.payload;
      if (payload.callerId !== CALLER_ID.THH_HUND_BASISDATEN) {
        return sectionState;
      }
      if (payload.orte?.length === 1) {
        const newState: BasisAdresse = { ...sectionState };
        newState.ort = payload.orte[0];
        return newState;
      }
      return sectionState;
    }
    case ThhHundActions.ORT_CHANGED: {
      return { ...sectionState, ort: action.payload };
    }
    case ThhHundActions.STRASSE_CHANGED: {
      return { ...sectionState, strasse: action.payload };
    }
    case ThhHundActions.HAUSNUMMER_CHANGED: {
      return { ...sectionState, hausnummer: action.payload };
    }
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      const risikoort: BasisAdresse = action.payload.versicherungsnehmer.adresse;
      return {
        ...sectionState,
        plz: risikoort.plz,
        strasse: risikoort.strasse,
        ort: risikoort.ort,
        hausnummer: risikoort.hausnummer,
      };
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: ThhHundVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.THH_HUND) {
        return {
          ...sectionState,
          plz: actionPayload.vnAdresse?.plz,
          strasse: actionPayload.vnAdresse?.strasse,
          hausnummer: actionPayload.vnAdresse?.hausnummer,
          ort: actionPayload.vnAdresse?.ort,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
